import { render, staticRenderFns } from "./NgModalOrdersReceive.vue?vue&type=template&id=1dbb4c3c"
import script from "./NgModalOrdersReceive.vue?vue&type=script&lang=js"
export * from "./NgModalOrdersReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports